export default __webpack_public_path__ + "static/media/hamburger-question-mark.350dd16d.svg";